import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useMemo, useState, useCallback, useRef } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { getUserInfo } from "../../redux/handlers/auth/getUserInfo.handler";
import { getAllMstDiscountType } from "../../redux/handlers/master/getAllMstDiscountType.handler";
import { getAllMstPaymentType } from "../../redux/handlers/master/getAllMstPaymentType.handler";
import { getAllMstPriceCategory } from "../../redux/handlers/master/getAllMstPriceCategory.handler";
import { getAllMstVat } from "../../redux/handlers/master/getAllMstVat.handler";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import { getFirstMstCompany } from "../../redux/handlers/master/getFirstMstCompany.handler";
import { isValidArray, mapBranchPaymentChannelToOptions, mapMstToOptions } from "utils/HelperFunction";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { getAllMstBranch } from "../../redux/handlers/master/getAllMstBranch.handler";
import { genNewInvoiceDocNumber } from "../../redux/slices/logic/genNewInvoiceDocNumber.slice";
import { useGlobalDocModalContext } from "contexts/GlobalDocModalContext";
import { mappingOptionNewItemInvoiceCol } from "utils/HelperInvoiceFunction";
import { getAllMstNewItemInvoiceCol } from "../../redux/slices/master/getAllMstNewItemInvoiceCol.slice";
import { getAllBranchPaymentChannel } from "../../redux/slices/master/getAllBranchPaymentChannel.slice";
import { getAllMstAdjustOrFee } from "../../redux/slices/master/getAllMstAdjustOrFee.slice";
import { useParams } from "react-router-dom";
import { initStateInvoiceData } from "mocks/invoiceData";
import useInvoiceModalInit from "./useInvoiceModalInit";
export var useInitInvoice = function() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var setModalNotiDocAlert = useGlobalDocModalContext().setModalNotiDocAlert;
    var modalInvoiceModalState = useInvoiceModalInit();
    var _useState = _sliced_to_array(useState(0), 2), sumproductPrice = _useState[0], setSumproductPrice = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), sumproductNoVat = _useState1[0], setSumproductNoVat = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), sumproductZeroVat = _useState2[0], setSumproductZeroVat = _useState2[1];
    var _useState3 = _sliced_to_array(useState(0), 2), sumproductSevenVat = _useState3[0], setSumproductSevenVat = _useState3[1];
    var _useState4 = _sliced_to_array(useState(0), 2), sumproductBeforeVat = _useState4[0], setSumproductBeforeVat = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), sumproductOrdered = _useState5[0], setSumproductOrdered = _useState5[1];
    var _useParams = useParams(), invoiceID = _useParams.invoiceID, doID = _useParams.doID;
    var _useState6 = _sliced_to_array(useState(initStateInvoiceData), 2), formdata = _useState6[0], setFormdata = _useState6[1];
    // Reducers
    var reducers = {
        paymentType: useAppSelector(function(state) {
            return state.getAllMstPaymentTypeReducer;
        }),
        priceCategory: useAppSelector(function(state) {
            return state.getAllMstPriceCategoryReducer;
        }),
        discountType: useAppSelector(function(state) {
            return state.getAllMstDiscountTypeReducer;
        }),
        vat: useAppSelector(function(state) {
            return state.getAllMstVatReducer;
        }),
        userInfo: useAppSelector(function(state) {
            return state.getUserInfoReducer;
        }),
        company: useAppSelector(function(state) {
            return state.getFirstMstCompanyReducer;
        }),
        genNewInvoiceNumber: useAppSelector(function(state) {
            return state.genNewInvoiceDocNumberReducer;
        }),
        invoiceItemCol: useAppSelector(function(state) {
            return state.getAllMstNewItemInvoiceColReducer;
        }),
        branch: useAppSelector(function(state) {
            return state.getAllMstBranchReducer;
        }),
        branchPaymentChannel: useAppSelector(function(state) {
            return state.getAllBranchPaymentChannelReducer;
        }),
        adjustOrFee: useAppSelector(function(state) {
            return state.getAllMstAdjustOrFeeReducer;
        })
    };
    // Local state
    var _useState7 = _sliced_to_array(useState(null), 2), userInfo = _useState7[0], setUserInfo = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), companyInfo = _useState8[0], setCompanyInfo = _useState8[1];
    // Derived options using useMemo for performance
    var options = useMemo(function() {
        var _reducers_paymentType_data, _reducers_priceCategory_data, _reducers_discountType_data, _reducers_vat_data, _reducers_invoiceItemCol_data, _reducers_branch_data, _reducers_branchPaymentChannel_data, _reducers_adjustOrFee_data, _reducers_paymentType_data1, _reducers_priceCategory_data1, _reducers_discountType_data1, _reducers_vat_data_data, _reducers_vat_data1, _reducers_invoiceItemCol_data1, _reducers_branch_data1, _reducers_branchPaymentChannel_data1, _reducers_adjustOrFee_data1;
        var optionsInit = {
            paymentType: [],
            priceCategory: [],
            discountType: [],
            vat: [],
            invoiceItemCol: [],
            branch: [],
            branchPaymentChannel: [],
            adjustOrFee: []
        };
        var isReady = isValidArray((_reducers_paymentType_data = reducers.paymentType.data) === null || _reducers_paymentType_data === void 0 ? void 0 : _reducers_paymentType_data.data) && isValidArray((_reducers_priceCategory_data = reducers.priceCategory.data) === null || _reducers_priceCategory_data === void 0 ? void 0 : _reducers_priceCategory_data.data) && isValidArray((_reducers_discountType_data = reducers.discountType.data) === null || _reducers_discountType_data === void 0 ? void 0 : _reducers_discountType_data.data) && isValidArray((_reducers_vat_data = reducers.vat.data) === null || _reducers_vat_data === void 0 ? void 0 : _reducers_vat_data.data) && isValidArray((_reducers_invoiceItemCol_data = reducers.invoiceItemCol.data) === null || _reducers_invoiceItemCol_data === void 0 ? void 0 : _reducers_invoiceItemCol_data.data) && isValidArray((_reducers_branch_data = reducers.branch.data) === null || _reducers_branch_data === void 0 ? void 0 : _reducers_branch_data.data) && isValidArray((_reducers_branchPaymentChannel_data = reducers.branchPaymentChannel.data) === null || _reducers_branchPaymentChannel_data === void 0 ? void 0 : _reducers_branchPaymentChannel_data.data) && isValidArray((_reducers_adjustOrFee_data = reducers.adjustOrFee.data) === null || _reducers_adjustOrFee_data === void 0 ? void 0 : _reducers_adjustOrFee_data.data);
        if (!isReady) return optionsInit;
        return {
            paymentType: mapMstToOptions(((_reducers_paymentType_data1 = reducers.paymentType.data) === null || _reducers_paymentType_data1 === void 0 ? void 0 : _reducers_paymentType_data1.data) || []),
            priceCategory: mapMstToOptions(((_reducers_priceCategory_data1 = reducers.priceCategory.data) === null || _reducers_priceCategory_data1 === void 0 ? void 0 : _reducers_priceCategory_data1.data) || []),
            discountType: mapMstToOptions(((_reducers_discountType_data1 = reducers.discountType.data) === null || _reducers_discountType_data1 === void 0 ? void 0 : _reducers_discountType_data1.data) || []),
            vat: (_reducers_vat_data1 = reducers.vat.data) === null || _reducers_vat_data1 === void 0 ? void 0 : (_reducers_vat_data_data = _reducers_vat_data1.data) === null || _reducers_vat_data_data === void 0 ? void 0 : _reducers_vat_data_data.map(function(item) {
                return {
                    label: item.name,
                    value: item.id,
                    vat: item.value
                };
            }),
            invoiceItemCol: mappingOptionNewItemInvoiceCol(((_reducers_invoiceItemCol_data1 = reducers.invoiceItemCol.data) === null || _reducers_invoiceItemCol_data1 === void 0 ? void 0 : _reducers_invoiceItemCol_data1.data) || []),
            branch: mapMstToOptions(((_reducers_branch_data1 = reducers.branch.data) === null || _reducers_branch_data1 === void 0 ? void 0 : _reducers_branch_data1.data) || []),
            branchPaymentChannel: mapBranchPaymentChannelToOptions(((_reducers_branchPaymentChannel_data1 = reducers.branchPaymentChannel.data) === null || _reducers_branchPaymentChannel_data1 === void 0 ? void 0 : _reducers_branchPaymentChannel_data1.data) || []),
            adjustOrFee: mapMstToOptions(((_reducers_adjustOrFee_data1 = reducers.adjustOrFee.data) === null || _reducers_adjustOrFee_data1 === void 0 ? void 0 : _reducers_adjustOrFee_data1.data) || [])
        };
    }, [
        reducers.paymentType.data,
        reducers.priceCategory.data,
        reducers.discountType.data,
        reducers.vat.data,
        reducers.invoiceItemCol.data,
        reducers.branch.data,
        reducers.branchPaymentChannel.data,
        reducers.adjustOrFee.data
    ]);
    var isInitInvoiceLoading = useMemo(function() {
        return reducers.paymentType.isFetching || reducers.priceCategory.isFetching || reducers.discountType.isFetching || reducers.vat.isFetching || reducers.userInfo.isFetching || reducers.company.isFetching || reducers.genNewInvoiceNumber.isFetching || reducers.invoiceItemCol.isFetching || reducers.branch.isFetching || reducers.branchPaymentChannel.isFetching || reducers.adjustOrFee.isFetching;
    }, [
        reducers.paymentType.isFetching,
        reducers.priceCategory.isFetching,
        reducers.discountType.isFetching,
        reducers.vat.isFetching,
        reducers.userInfo.isFetching,
        reducers.company.isFetching,
        reducers.genNewInvoiceNumber.isFetching,
        reducers.invoiceItemCol.isFetching,
        reducers.branch.isFetching,
        reducers.branchPaymentChannel.isFetching,
        reducers.adjustOrFee.isFetching
    ]);
    // Load master data
    var loadMstData = useCallback(function() {
        dispatch(getAllMstPaymentType());
        dispatch(getAllMstPriceCategory());
        dispatch(getAllMstDiscountType());
        dispatch(getAllMstVat());
        dispatch(getAllWarehouse());
        dispatch(getFirstMstCompany());
        dispatch(getAllMstNewItemInvoiceCol());
        dispatch(getAllMstBranch());
        dispatch(getAllBranchPaymentChannel());
        dispatch(getAllMstAdjustOrFee());
    }, []);
    // Load resources
    var loadResources = useCallback(function() {
        dispatch(getUserInfo({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
        if (!invoiceID) {
            var queryParams = {
                isTaxInvoice: formdata.is_tax_invoice
            };
            dispatch(genNewInvoiceDocNumber({
                modalObj: modalObj,
                setModalObj: setModalObj,
                queryParams: queryParams
            }));
        }
    }, [
        invoiceID
    ]);
    // Handle incoming data
    useEffect(function() {
        if (reducers.userInfo.data && reducers.userInfo.data !== userInfo) {
            setUserInfo(reducers.userInfo.data.data);
        }
        if (reducers.company.data && reducers.company.data !== companyInfo) {
            setCompanyInfo(reducers.company.data.data);
        }
        if (reducers.genNewInvoiceNumber.data && !invoiceID && reducers.genNewInvoiceNumber.data.data !== formdata.doc_number) {
            setFormdata(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    doc_number: reducers.genNewInvoiceNumber.data.data
                });
            });
            setModalNotiDocAlert(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    extra: {
                        genDocNumber: reducers.genNewInvoiceNumber.data.data,
                        createdDocNumber: prev.extra.createdDocNumber
                    }
                });
            });
        }
    }, [
        reducers.userInfo.data,
        reducers.company.data,
        reducers.genNewInvoiceNumber.data,
        userInfo,
        companyInfo,
        formdata.doc_number,
        invoiceID
    ]);
    // Auto-load
    useEffect(function() {
        loadMstData();
        loadResources();
    }, [
        loadMstData,
        loadResources
    ]);
    return {
        isInitInvoiceLoading: isInitInvoiceLoading,
        options: options,
        userInfo: userInfo,
        companyInfo: companyInfo,
        formdata: formdata,
        setFormdata: setFormdata,
        modalInvoiceModalState: modalInvoiceModalState,
        sumproductPrice: sumproductPrice,
        setSumproductPrice: setSumproductPrice,
        sumproductNoVat: sumproductNoVat,
        setSumproductNoVat: setSumproductNoVat,
        sumproductZeroVat: sumproductZeroVat,
        setSumproductZeroVat: setSumproductZeroVat,
        sumproductSevenVat: sumproductSevenVat,
        setSumproductSevenVat: setSumproductSevenVat,
        sumproductBeforeVat: sumproductBeforeVat,
        setSumproductBeforeVat: setSumproductBeforeVat,
        sumproductOrdered: sumproductOrdered,
        setSumproductOrdered: setSumproductOrdered
    };
};
